import {
  GET_PAGES,
  GET_PAGES_SUCCESS,
  CREATE_PAGE_SUCCESS,
  CLEAR_LAST_CREATED_PAGE_ID,
  CLEAR_ACTUAL_PAGE_ID,
} from "./constants"

const initialState = {
  list: [],
  pagePermissions: [],
  folders: [],
  idActualPage: "",
  lastCreatedPageId: "",
}

//

function pageListReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_PAGES_SUCCESS:
      return {
        ...state,
        list: payload.pages,
        pagePermissions: payload.permissions,
        folders: payload.folders,
      }
    case CREATE_PAGE_SUCCESS:
      return {
        ...state,
        idActualPage: payload,
        lastCreatedPageId: payload,
      }
    case CLEAR_LAST_CREATED_PAGE_ID:
      return {
        ...state,
        lastCreatedPageId: "",
      }
    case CLEAR_ACTUAL_PAGE_ID:
      return {
        ...state,
        idActualPage: "",
      }
    default:
      return state
  }
}

export default pageListReducer
